import { useContext } from "react";

import { Flex } from "@mantine/core";

import { NavbarContext } from "@/contexts/navbar";
import { OmniSearch } from "@/omni-search";

import { HEADER_HEIGHT } from "../constants/header";

import NavBarBurger from "./NavBarBurger";
import NavBarToggleButton from "./NavBarToggleButton";
import UserMenu from "./UserMenu";

export default function Header() {
  const { collapsed, toggleCollapsed } = useContext(NavbarContext);

  return (
    <Flex align="center" h={HEADER_HEIGHT} justify="space-between" px={{ base: "md", sm: "lg" }}>
      <NavBarToggleButton visibleFrom="sm" collapsed={collapsed} toggle={toggleCollapsed} />
      {collapsed && <NavBarBurger />}
      <OmniSearch />
      <UserMenu />
    </Flex>
  );
}
